import { useAuth, AUTH_LEVEL } from '@/hooks/use-auth';
import React from 'react';

/**
 * Auth权限组件
 * @param {string} code - 权限代码
 * @param {number} level - 最低权限级别，默认为1（只读）。可选值：1=只读, 2=可写, 3=完全访问
 * @param {React.ReactNode} children - 有权限时渲染的内容
 * @param {React.ReactNode} fallback - 无权限时渲染的内容，默认为null
 * @returns {React.ReactNode|null} - 有权限返回children，无权限返回fallback
 */
export const Auth = ({ code, level = AUTH_LEVEL.READ_ONLY, children, fallback = null }) => {
    const hasPermission = useAuth(code, level);
    return hasPermission ? children : fallback;
};

// 导出权限级别常量，方便使用
export { AUTH_LEVEL };

export default Auth;
